/** Settings page: tabs for every configuration area. */
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "../../components/ui/PageHeader.js";
import { usePermissions } from "../../lib/auth.js";
import { FlatSections } from "../shared.js";
import { CompanyHolidaysPanel } from "../employees/Holidays.js";
import { AIUsagePanel } from "./ai-usage.js";
import { SystemAdminPanel } from "./system-admin.js";
import { RoleSettingsPanel } from "./roles.js";
import { WebhookSettingsPanel } from "./webhooks.js";
import { CompanyForm, LocalizationForm } from "./company.js";
import { BillingForm } from "./billing.js";
import { DocumentsForm } from "./documents.js";
import { CategoriesForm } from "./categories.js";
import { SystemPanel, WorkSettingsForm } from "./system.js";

export function SettingsPage() {
  const { t } = useTranslation();
  const { isAdmin, has } = usePermissions();
  const [searchParams] = useSearchParams();
  const tabs = [
    "company",
    ...(has("finance.view") ? ["billing"] : []),
    "documents",
    "localization",
    "categories",
    ...(has("time.manage") ? ["holidays"] : []),
    ...(has("roles.view") ? ["roles"] : []),
    ...(isAdmin ? ["ai"] : []),
    ...(has("automations.view") ? ["automations"] : []),
    ...(has("settings.system.edit") ? ["system"] : []),
    ...(isAdmin ? ["systemAdmin"] : []),
  ];
  const requestedTab = searchParams.get("tab");
  const tab =
    requestedTab && tabs.includes(requestedTab) ? requestedTab : "company";
  return (
    <>
      <PageHeader
        title={t("settings.title", {
          defaultValue: "Settings",
        })}
        subtitle={t("settings.subtitle", {
          defaultValue: "Company, billing and application configuration.",
        })}
      />
      <FlatSections>
        <div className="min-w-0">
          {tab === "company" ? (
            <div className="space-y-5">
              <CompanyForm />
              <WorkSettingsForm />
            </div>
          ) : null}
          {tab === "billing" ? <BillingForm /> : null}
          {tab === "documents" ? <DocumentsForm /> : null}
          {tab === "localization" ? <LocalizationForm /> : null}
          {tab === "categories" ? <CategoriesForm /> : null}
          {tab === "holidays" ? <CompanyHolidaysPanel /> : null}
          {tab === "roles" ? <RoleSettingsPanel /> : null}
          {tab === "system" ? <SystemPanel /> : null}
          {tab === "ai" ? <AIUsagePanel /> : null}
          {tab === "automations" ? <WebhookSettingsPanel /> : null}
          {tab === "systemAdmin" ? <SystemAdminPanel /> : null}
        </div>
      </FlatSections>
    </>
  );
}
